import React, { memo, forwardRef, useCallback } from 'react';
import { createUseStyles, Link } from '@Sage/hoi-poi-ui';
import ExcelIcon from '../../icons/ExcelIcon';

import styles from './styles';
const useStyles = createUseStyles(styles, 'FileNameFormatter');

const FileNameFormatter = ({ onDownload, data, value }, ref) => {
    const classes = useStyles();
    const onClick = useCallback(() => {
        onDownload(data);
    }, [data, onDownload]);
    return (
        <div ref={ref} className={classes.fileName} onClick={onClick}>
            <div>
                <ExcelIcon />
            </div>
            <div>
                <Link className="ag-grid-link-hover">{value}</Link>
            </div>
        </div>
    );
};

export default memo(forwardRef(FileNameFormatter));
